module.exports = __webpack_public_path__ + "img/milan.9ab6e094.jpeg";